import store from "../store";

export default function () {
    const urlParams = new URLSearchParams(window.location.search);
    const campaignId = urlParams.get('campaignId') || urlParams.get('cid');
    const googleClickId = urlParams.get('gclid') ?? urlParams.get('tmt_data');
    const clickId = urlParams.get('clickid') ?? urlParams.get('clickId') ?? urlParams.get('click_id') ?? urlParams.get('ofreqid');
    return {
        campaignId: campaignId ?? store.state.campaignId,
        googleClickId: googleClickId ?? store.state.googleClickId,
        clickId: clickId ?? store.state.googleClickId
    }

}
